import * as React from 'react';
import type { SVGProps } from 'react';
const X = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M208.49 191.51C210.744 193.764 212.011 196.822 212.011 200.01C212.011 203.198 210.744 206.256 208.49 208.51C206.236 210.764 203.178 212.031 199.99 212.031C196.802 212.031 193.744 210.764 191.49 208.51L128 145L64.4901 208.49C62.2357 210.744 59.1782 212.011 55.9901 212.011C52.8019 212.011 49.7444 210.744 47.4901 208.49C45.2357 206.236 43.9692 203.178 43.9692 199.99C43.9692 196.802 45.2357 193.744 47.4901 191.49L111 128L47.5101 64.49C45.2557 62.2357 43.9892 59.1782 43.9892 55.99C43.9892 52.8019 45.2557 49.7444 47.5101 47.49C49.7644 45.2357 52.8219 43.9692 56.0101 43.9692C59.1982 43.9692 62.2557 45.2357 64.5101 47.49L128 111L191.51 47.48C193.764 45.2257 196.822 43.9592 200.01 43.9592C203.198 43.9592 206.256 45.2257 208.51 47.48C210.764 49.7344 212.031 52.7919 212.031 55.98C212.031 59.1682 210.764 62.2257 208.51 64.48L145 128L208.49 191.51Z"
      fill="currentColor"
    />
  </svg>
);
export default X;
